import React, { Component } from 'react';
import { errorLayout as ErrorLayout } from  '../../helper/layout-helper';
import AppStore from '../../store/appStore';
import { Link } from 'react-router';
import { EnvironmentService } from '../../services/EnvironmentService';

const env = new EnvironmentService();

export class SystemErrorPage extends Component {

  constructor() {
    super();
    this.state = {};
  }

  componentWillMount() {
    this.setState({ error: AppStore.getAppError() })
  }

  render() {
    if (!env.is2Eskimos) {
      return (
        <div className="esk-system-error-page base-content-area">
          <ErrorLayout hideCode error={this.state.error} />

          <div className="col-sm-12 text-center">
            <Link to="/">Back to Home</Link>
          </div>
        </div>
        );
    }

    return (
      <div className="login-page animated fadeInDown smart-style-6">
        <div id="content">
          <div className="row">
            <div className="col-sm-12" style={{ margin: '450px auto 10px auto' }}>
              <ErrorLayout hideCode error={this.state.error} />
            </div>
            <div className="col-sm-12 text-center">
              <Link to="/">Back to Home</Link>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
